/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */

namespace network_ui {

   import IRootScopeService = angular.IRootScopeService;

   /**
    * Provides methods for creating the mutation spec sent to the backend
    * services after the completion of the Migrate VM networks wizard.
    */
   export class VmMigrateWizardSpecFactory {

      public static $inject = ["defaultUriSchemeUtil", "vmMigrateWizardConstants"];

      constructor(private defaultUriSchemeUtil: any,
                  private wizardConstants: any) {
      }

      /**
       * Builds the spec for the Migrate VM networks operation.
       *
       * @param model VmMigrateWizardModel
       */
      public buildVmMigrateSpec(model: VmMigrateWizardModel): any {
         let listItems: any[] = model.treeListItemData;

         let vmVnicSpecs: any[] = [];

         for (let listItem of listItems) {

            if (listItem.isChecked &&
                  listItem.id !== this.wizardConstants.ALL_VMS_ITEM_ID &&
                  !listItem.virtualEthernetCard) {

               let vmItem: any = listItem;

               let vmVnicItems =_.filter(listItems, function(item: any) {
                  return item.isChecked &&
                        item.virtualEthernetCard &&
                        item.parentId === listItem.id;
               });

               let vmVnics: any[] = [];

               for (let vmVnicItem of vmVnicItems) {
                  vmVnics.push(vmVnicItem.virtualEthernetCard);
               }

               let vmVnicSpec: any = {
                  _type: this.wizardConstants.specs.VM_MIGRATE_VM_VNICS_SPEC,
                  vmRef: this.defaultUriSchemeUtil.getManagedObjectReference(vmItem.id),
                  vmChangeVersion: vmItem.changeVersion,
                  vnics: vmVnics
               };

               vmVnicSpecs.push(vmVnicSpec);
            }
         }

         return {
            vmVnicsSpecs: vmVnicSpecs,
            destinationNetwork: model.destinationNetworkData
         };
      }
   }

   angular.module("com.vmware.vsphere.client.network")
         .service("vmMigrateWizardSpecFactory", VmMigrateWizardSpecFactory);
}
